module.exports = __webpack_public_path__ + "static/media/facebook-colored.5d1a2d17.svg";